import React from 'react'
import { Input } from 'antd';
const { TextArea } = Input;

const TextInputBox = ({label,placeholder,value,onChangeValue}) => {
  return (
    <div className='d-flex flex-column gap-2'>
       <label>{label}</label>
       <TextArea placeholder={placeholder} value={value} onChange={(e) =>onChangeValue(e.target.value)} autoSize/>
    </div>
  )
}

export default TextInputBox
